
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      title: {
        type: Object,
        default: null
      }
    };
  }
};
